import { InitialValuesBuilder, OfferDesignTypes, OfferTypeFormConfig } from 'views/OfferDesign/OfferDesign.types';

import { BundleFormFields } from './components/FormFields/BundleFormFields/BundleFormFields';
import { PopupFormFields } from './components/FormFields/PopupFormFields/PopupFormFields';
import { ProgressBarFormFields } from './components/FormFields/ProgressBarFormFields/ProgressBarFormFields';
import { PromotionFormFields } from './components/FormFields/PromotionFormFields/PromotionFormFields';
import { RewardCalendarFormFields } from './components/FormFields/RewardCalendarFormFields/RewardCalendarFormFields';
import { RollingOfferFormFields } from './components/FormFields/RollingOfferFormFields/RollingOfferFormFields';
import { TriggeredPopupFormFields } from './components/FormFields/TriggeredPopupFormFields/TriggeredPopupFormFields';
import {
  buildBundlePayload,
  buildPopupInitialValues,
  buildPopupPayload,
  buildProgressBarInitialValues,
  buildProgressBarPayload,
  buildPromotionInitialValues,
  buildPromotionPayload,
  buildRewardCalendarInitialValues,
  buildRewardCalendarPayload,
  buildRollingOfferInitialValues,
  buildRollingOfferPayload,
  buildTriggeredPopupInitialValues,
  buildTriggeredPopupPayload,
  bundleSchema,
  popupSchema,
  progressBarSchema,
  promotionSchema,
  rewardCalendarSchema,
  rollingOfferSchema,
  triggeredPopupSchema
} from './utils';

const OFFER_TYPE_CONFIG: Record<OfferDesignTypes, OfferTypeFormConfig> = {
  [OfferDesignTypes.Bundle]: {
    FormFields: BundleFormFields,
    schema: bundleSchema,
    buildPayload: buildBundlePayload
  },
  [OfferDesignTypes.SpecialOffer]: {
    FormFields: PromotionFormFields,
    schema: promotionSchema,
    buildPayload: buildPromotionPayload
  },
  [OfferDesignTypes.ProgressBar]: {
    FormFields: ProgressBarFormFields,
    schema: progressBarSchema,
    buildPayload: buildProgressBarPayload
  },
  [OfferDesignTypes.RollingOffer]: {
    FormFields: RollingOfferFormFields,
    schema: rollingOfferSchema,
    buildPayload: buildRollingOfferPayload
  },
  [OfferDesignTypes.PopUp]: {
    FormFields: PopupFormFields,
    schema: popupSchema,
    buildPayload: buildPopupPayload
  },
  [OfferDesignTypes.TriggeredPopup]: {
    FormFields: TriggeredPopupFormFields,
    schema: triggeredPopupSchema,
    buildPayload: buildTriggeredPopupPayload
  },
  [OfferDesignTypes.RewardCalendar]: {
    FormFields: RewardCalendarFormFields,
    schema: rewardCalendarSchema,
    buildPayload: buildRewardCalendarPayload
  }
};

export const getOfferTypeConfig = (
  offerType: OfferDesignTypes
): OfferTypeFormConfig | undefined =>
  OFFER_TYPE_CONFIG[offerType];

const INITIAL_VALUES_BUILDERS: Partial<Record<OfferDesignTypes, InitialValuesBuilder>> = {
  [OfferDesignTypes.SpecialOffer]: buildPromotionInitialValues,
  [OfferDesignTypes.ProgressBar]: buildProgressBarInitialValues,
  [OfferDesignTypes.PopUp]: buildPopupInitialValues,
  [OfferDesignTypes.TriggeredPopup]: buildTriggeredPopupInitialValues,
  [OfferDesignTypes.RollingOffer]: buildRollingOfferInitialValues,
  [OfferDesignTypes.RewardCalendar]: buildRewardCalendarInitialValues
};

export const getInitialValuesBuilder = (
  offerType: OfferDesignTypes
): InitialValuesBuilder | undefined =>
  INITIAL_VALUES_BUILDERS[offerType];
